module.exports = __webpack_public_path__ + "front/img/p1.3d9fb801.png";